export enum UserAction {
  AddNew,
  AddFromExisting,
  Update
}
